import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { DEFAULT_LOCALE } from 'constants/General'
import store from 'store'
import { getFromStorage, UNITE_LANGUAGE_KEY } from './constants/LocalStorage'
import { getLanguageWithCountry } from './modules/Helpers'
// translation files
import EN_TRANSLATION from './translations/en.json'
import ES_TRANSLATION from './translations/es.json'
import PT_TRANSLATION from './translations/pt.json'
import FR_CA_TRANSLATION from './translations/fr-CA.json'
import EN_CA_TRANSLATION from './translations/en-CA.json'

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    interpolation: {
      escapeValue: false, // react already safes from xss
      format(value, format) {
        if (format === 'call-format' && value instanceof Date) {
          const time = new Intl.DateTimeFormat('default', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
          }).format(value)

          return `${value.getDate()}, ${value.getFullYear()} @ ${time}`
        }
        if (format === 'call-day' && value instanceof Date) {
          return value.getDay()
        }
        if (format === 'call-month' && value instanceof Date) {
          return value.getMonth()
        }
        return value
      },
    },
    lng: (() => {
      const baseLanguage = getFromStorage(UNITE_LANGUAGE_KEY) || DEFAULT_LOCALE
      const { country } = store?.getState()?.config || {}
      return getLanguageWithCountry(baseLanguage, country?.code)
    })(),
    fallbackLng: DEFAULT_LOCALE,
    resources: {
      en: { translation: EN_TRANSLATION },
      es: { translation: ES_TRANSLATION },
      pt: { translation: PT_TRANSLATION },
      fr: { translation: FR_CA_TRANSLATION },
      'en-CA': { translation: EN_CA_TRANSLATION },
      'fr-CA': { translation: FR_CA_TRANSLATION },
    },
  })

export default i18n
